import MDropdown from './Dropdown.vue';

export default MDropdown;
